import { Spacing } from 'UI'

export default theme => ({
  overlay: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'rgba(0,0,0,.92)',
    zIndex: 99999,
    display: 'flex',
    alignItems: 'center'
  },
  wrapper: {
    width: '100%'
  },
  closeIcon: {
    color: theme.neutral[0],
    fontSize: 16,
    marginBottom: 24,
    textAlign: 'right',
    '& > *': {
      cursor: 'pointer',
      lineHeight: 1
    }
  },
  header: {
    backgroundColor: theme.neutral[0],
    alignItems: 'center',
    overflow: 'hidden',
    margin: Spacing(0, 0, 4, 0),
    padding: 24
  },
  title: {
    flex: '1 0'
  },
  button: {
    flex: '0 1 30%',
    height: 54
  },
  video: {
    position: 'relative',
    paddingTop: '56.25%'
  },
  videoInner: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 4,
    overflow: 'hidden'
  },
  socialMedia: {
    width: '100%',
    margin: () => Spacing(4, 0, 0, 0),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
})
